export const ERROR_CODES = {
  VALIDATION_FAILURE_LIST: 422
}
